module.exports = __webpack_public_path__ + "media/update-best-time.89985d6e.mp3";